export default "<div class=\"map\" id=\"map-point\"></div>\n";